import { render, staticRenderFns } from "./DescrizioneEsito.vue?vue&type=template&id=45d4119a&"
import script from "./DescrizioneEsito.vue?vue&type=script&lang=js&"
export * from "./DescrizioneEsito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports